<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    <BusinessEntityInput v-model="companyNo" :label="$t('Company reg. no.')" name="company_no">
      <CompanyNumberTooltip class="m-l-5" :market="complianceData.market" />
    </BusinessEntityInput>
    <BusinessEntityInput
      v-model="registeredCompanyName"
      :label="$t('Registered company name')"
      name="registered_company_name"
    />

    <BusinessEntityVat
      v-if="complianceData.isVatApplicable"
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
    />

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <SubmitButton class="m-t-20" :text="$t('Save')" auto-submit :disabled="!canSave" />
  </div>
</template>

<script>
/* eslint-disable import/extensions */
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVat from '@/components/compliances/BusinessEntity/BusinessEntityVat.vue'
import CompanyNumberTooltip from '@/components/compliances/BusinessEntity/CompanyNumberTooltip.vue'
import { deepClone } from '@/utils/tools'

export default {
  components: {
    BusinessEntityInput,
    BusinessEntityVat,
    CompanyNumberTooltip,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)
    return {
      internalBusinessEntity,
    }
  },
  computed: {
    canSave() {
      return this.registeredCompanyName && this.companyNo
    },
    companyNo: {
      get() {
        return this.internalBusinessEntity.companyNo
      },
      set(companyNo) {
        this.internalBusinessEntity.companyNo = companyNo
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    registeredCompanyName: {
      get() {
        return this.internalBusinessEntity.companyName
      },
      set(registeredCompanyName) {
        this.internalBusinessEntity.companyName = registeredCompanyName
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
  },
}
</script>
